<script>
import Diff from './Diff';

export default {
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  methods: {
    handleClose () {
      this.$emit('close');
    },
  },
  render () {
    const { $style, data } = this;

    return (
      <u-modal onClose={this.handleClose}>
        <u-title
          slot="header"
          level="2"
        >
          Изменения
        </u-title>

        <div class={$style.wrapper}>
          <Diff
            entityId={data.entityId}
            entityType={data.entityType}
            changes={data.diff}
          />
        </div>
      </u-modal>
    );
  },
};
</script>

<style lang="scss" module>
@import '@/theme/include.scss';

.wrapper {
  color: inherit;
}
</style>
